import { apolloClient } from '@/plugins/apollo';
import { ReviewCriteria } from '@/models';
import {
  CreateReviewCriteria,
  UpdateReviewCriteria,
  DeleteReviewCriteria,
} from '@/graphql';

const actions = {
  async saveReviewCriteria(context, reviewCriteria) {
    const mutation = reviewCriteria.id
      ? UpdateReviewCriteria
      : CreateReviewCriteria;
    const response = await apolloClient.mutate({
      mutation,
      variables: {
        reviewCriteria: reviewCriteria.creationData(),
      },
      refetchQueries: ['GetReviewForSettingsPage'],
    });

    const data = reviewCriteria.id
      ? response.data.updateReviewCriteria
      : response.data.createReviewCriteria;
    return new ReviewCriteria(data);
  },
  async deleteReviewCriteria(context, reviewCriteria) {
    await apolloClient.mutate({
      mutation: DeleteReviewCriteria,
      variables: {
        id: reviewCriteria.id,
      },
      refetchQueries: ['GetReviewForSettingsPage'],
    });
  },
};

export default {
  namespaced: true,
  actions,
};
